import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions =  {}
export type GetVisitTransactionsForAccountsQueryVariables = Types.Exact<{
  accountUuids?: Types.Maybe<Array<Types.Maybe<Types.Scalars['UUID']>> | Types.Maybe<Types.Scalars['UUID']>>;
  startTime: Types.Scalars['DateTime'];
  endTime: Types.Scalars['DateTime'];
}>;


export type GetVisitTransactionsForAccountsQuery = (
  { __typename?: 'Query' }
  & { getVisitTransactionsForAccounts?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'PaymentRequestNode' }
    & Pick<Types.PaymentRequestNode, 'accountUuid' | 'productUuid' | 'eligibilityReferenceUuid' | 'isFullyPaid' | 'status'>
    & { transactions?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'TransactionNode' }
      & Pick<Types.TransactionNode, 'amount' | 'source' | 'type' | 'responsibleParty' | 'createdAt'>
    )>>> }
  )>>> }
);


export const GetVisitTransactionsForAccountsDocument = gql`
    query GetVisitTransactionsForAccounts($accountUuids: [UUID], $startTime: DateTime!, $endTime: DateTime!) {
  getVisitTransactionsForAccounts(
    accountUuids: $accountUuids
    startTime: $startTime
    endTime: $endTime
  ) {
    accountUuid
    productUuid
    eligibilityReferenceUuid
    isFullyPaid
    status
    transactions {
      amount
      source
      type
      responsibleParty
      createdAt
    }
  }
}
    `;

/**
 * __useGetVisitTransactionsForAccountsQuery__
 *
 * To run a query within a React component, call `useGetVisitTransactionsForAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitTransactionsForAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitTransactionsForAccountsQuery({
 *   variables: {
 *      accountUuids: // value for 'accountUuids'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetVisitTransactionsForAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVisitTransactionsForAccountsQuery, GetVisitTransactionsForAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVisitTransactionsForAccountsQuery, GetVisitTransactionsForAccountsQueryVariables>(GetVisitTransactionsForAccountsDocument, options);
      }
export function useGetVisitTransactionsForAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVisitTransactionsForAccountsQuery, GetVisitTransactionsForAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVisitTransactionsForAccountsQuery, GetVisitTransactionsForAccountsQueryVariables>(GetVisitTransactionsForAccountsDocument, options);
        }
export type GetVisitTransactionsForAccountsQueryHookResult = ReturnType<typeof useGetVisitTransactionsForAccountsQuery>;
export type GetVisitTransactionsForAccountsLazyQueryHookResult = ReturnType<typeof useGetVisitTransactionsForAccountsLazyQuery>;
export type GetVisitTransactionsForAccountsQueryResult = ApolloReactCommon.QueryResult<GetVisitTransactionsForAccountsQuery, GetVisitTransactionsForAccountsQueryVariables>;